import SportCodes from "../../sports/common/sport-codes";
import FootballSyncService from "./football-sync-service";
import TennisSyncService from "./tennis-sync-service";

class SyncServiceFactory {
    constructor() {
        this.syncServices = {
            [SportCodes.Football]: FootballSyncService,
            [SportCodes.FlagFootball]: FootballSyncService,
            [SportCodes.Tennis]: TennisSyncService,
            [SportCodes.WomenTennis]: TennisSyncService
        };
    }

    getInstance(sportId) {
        return this.syncServices[sportId];
    }
}

export default new SyncServiceFactory();
